<template lang="html">
  <div v-if="accordionItems.length" class="attributes-section">
    <UAccordion
      type="multiple"
      :items="accordionItems"
      :ui="{
        content: 'p-4 pt-0',
        root: 'border border-neutral-400',
        label: 'py-2 px-4',
        trailingIcon: 'mr-4',
      }"
    >
      <template #content="{ item }">
        <div class="flex flex-col gap-2">
          <AttributeDisplay
            v-for="attribute in item.attributes"
            :key="attribute.metadata.id"
            :attribute="attribute"
          />
        </div>
      </template>
    </UAccordion>
  </div>
</template>

<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'
import type {
  ProductDto,
  ProductAttributeValueSlotDto,
} from '@repo/api/web/models'

import AttributeDisplay from './Attributes/AttributeDisplay.vue'

interface AttributesGroupItem extends AccordionItem {
  attributes: ProductAttributeValueSlotDto[]
}

const props = defineProps<{
  value: ProductDto
}>()

const wellKnownSystemNames = computed(() =>
  Object.keys(props.value.wellKnownAttributes || {}),
)

const variantKeyAttributeIds = computed(() =>
  Object.keys(props.value.variants?.keyWithValues || {}),
)

const accordionItems = computed<AttributesGroupItem[]>(() => {
  if (!props.value.groups?.length) return []

  return props.value.groups
    .map((group) => {
      const attrs = group.attributes || []
      const filteredAttributes = attrs.filter(
        attr =>
          attr.metadata.isScalar
          && !wellKnownSystemNames.value.includes(
            attr.metadata.systemName || attr.metadata.displayName || '',
          )
          && !variantKeyAttributeIds.value.includes(String(attr.metadata.id)),
      )

      return {
        label: group.group?.displayName || 'Прочие атрибуты',
        value: String(group.group?.id || 'Общее'),
        attributes: filteredAttributes,
      }
    })
    .filter(item => item.attributes.length > 0)
})
</script>
